import onRemoveMeeting from '../actions/actionCreators/onRemoveMeeting';
import { listViewStore, getRowKeysFromRowIds, isConversationView } from 'owa-mail-list-store';
import tombstoneOperations, { TombstoneReasonType } from 'owa-mail-list-tombstone';
import { orchestrator } from 'satcheljs';

// This will be called after a meeting is removed using the RSVP button on the LV
export default orchestrator(onRemoveMeeting, actionMessage => {
    const { tableViewId, conversationId } = actionMessage;
    const tableView = listViewStore.tableViews.get(tableViewId);

    // We are only interested to tombstone the conversation
    if (isConversationView(tableView)) {
        const rowKeys = getRowKeysFromRowIds([conversationId], tableView);

        // In case there is no rowKeys to be updated
        if (rowKeys.length === 0) {
            return;
        }

        // We are going to tombstone the meeting removed from the table
        tombstoneOperations.add(rowKeys, tableView, TombstoneReasonType.MeetingRemove);
    }
});
